import {Component, Input, OnInit} from '@angular/core';
import {candidatAccepted} from "../../../../../../shared/utils/data/shared.data";
import {CandidatesApplied} from "../../../../../../models/Mission";
import {displayImg, textSubstring} from "../../../../../../shared/utils/utils.functions";
import {environment} from "../../../../../../../environments/environment";
import {CandidatService} from "../../../../../../services/candidat.service";
import {MatTooltip} from "@angular/material/tooltip";
import { CandidatStatusOnMission } from '../../../../../../shared/utils/enums';

@Component({
  selector: 'app-candidatures-mission',
  templateUrl: './candidatures-mission.component.html',
  standalone: true,
  imports: [
    MatTooltip
  ],
  styleUrl: './candidatures-mission.component.scss'
})
export class CandidaturesMissionComponent implements OnInit{
  @Input() text : string = "User Name"
  @Input() imageSrc : string = ""
  @Input() data: any;
  @Input() column: any; // Define input property for 'column'


  candidatList: CandidatesApplied[] = []
  indexAcceptedCandidate: number;
  candidatureTotalCount: number = 0;

  constructor(private candidatService: CandidatService) {
  }
  ngOnInit(): void {
    if (this.data.isfragmentable) {
      const uniqueCandidatIds = new Set(this.data.fragments.map((item: any) => item.candidatId));
      this.candidatureTotalCount = uniqueCandidatIds.size;
    } else {
      this.candidatList = this.data.candidatesApplied;
      this.indexAcceptedCandidate = this.candidatList.findIndex(c => candidatAccepted.includes(c.statusOfCandidatOnMission) && c.statusOfCandidatOnMission != CandidatStatusOnMission.CANCELED_BY_INTERIM_AGENCY);
    }
  }



  protected readonly textSubstring = textSubstring;
  protected readonly environment = environment;
  protected readonly displayImg = displayImg;
}
